module.exports = __webpack_public_path__ + "static/media/BUSINESS SEGMENTS.d8426177.svg";